import { useCallback } from "react";

import type { OptionPmsItemFromReservationCommentInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Query from "../../query";
import * as Schema from "../schema";

export const useOptionPmsItemFromReservationUpdateCommentMutation = () => {
	const { mutationFunc } = useCustomMutation(
		Schema.OPTION_PMS_ITEM_FROM_RESERVATION_UPDATE_COMMENT_FOR_OPTION_PMS_MUTATION,
	);

	const onUpdateOptionPmsItemFromReservationComment = useCallback(
		async (input: OptionPmsItemFromReservationCommentInput) =>
			mutationFunc({
				variables: { input },
				refetchQueries: [Query.Schema.OPTION_PMS_ACTIVE_LIST_FOR_OPTION_PMS],
			}),
		[mutationFunc],
	);

	return { onUpdateOptionPmsItemFromReservationComment };
};
